var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDimensionamento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 105,
    r: 99.5,
    fill: "#FFFF",
    stroke: "#DFDFDF",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 129.792,
    width: 48.8542,
    height: 140,
    rx: 24.4271,
    transform: "rotate(-90 35 129.792)",
    fill: "#EAFBF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 126.792,
    width: 42.8542,
    height: 134,
    rx: 21.4271,
    transform: "rotate(-90 38 126.792)",
    stroke: "#91C8AA",
    strokeOpacity: 0.58,
    strokeWidth: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3854,
    y: 35,
    width: 52.9134,
    height: 140,
    rx: 26.4567,
    fill: "#EAFBF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3854,
    y: 38,
    width: 46.9134,
    height: 134,
    rx: 23.4567,
    stroke: "#91C8AA",
    strokeOpacity: 0.58,
    strokeWidth: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5827,
    y: 87.9134,
    width: 58.4252,
    height: 35.2756,
    fill: "#EAFBF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.449 132.008C103.556 132.008 102.7 131.849 101.882 131.53C101.063 131.212 100.331 130.734 99.6866 130.097L79.7449 110.328C78.0087 108.613 76.7313 106.654 75.9128 104.449C75.0943 102.244 74.685 99.9414 74.685 97.5407C74.685 92.4943 76.3468 88.1583 79.6705 84.5328C82.9941 80.9073 87.1362 79.0945 92.0968 79.0945C94.4779 79.0945 96.7226 79.5599 98.8309 80.4908C100.939 81.4217 102.812 82.72 104.449 84.3858C106.036 82.72 107.884 81.4217 109.992 80.4908C112.101 79.5599 114.345 79.0945 116.726 79.0945C121.687 79.0945 125.842 80.9073 129.19 84.5328C132.538 88.1583 134.213 92.4698 134.213 97.4672C134.213 99.8679 133.791 102.171 132.948 104.375C132.104 106.58 130.839 108.54 129.153 110.255L109.137 130.097C108.492 130.734 107.772 131.212 106.979 131.53C106.185 131.849 105.342 132.008 104.449 132.008ZM107.425 93.7926C107.921 93.7926 108.393 93.9151 108.839 94.1601C109.285 94.4051 109.633 94.7235 109.881 95.1155L114.941 102.612H127.293C127.64 101.779 127.9 100.934 128.074 100.076C128.247 99.2187 128.334 98.3491 128.334 97.4672C128.235 94.0866 127.094 91.1837 124.911 88.7585C122.729 86.3333 120 85.1207 116.726 85.1207C115.189 85.1207 113.713 85.4147 112.299 86.0026C110.885 86.5905 109.657 87.4479 108.616 88.5748L106.607 90.706C106.359 91 106.036 91.2327 105.639 91.4042C105.243 91.5757 104.846 91.6614 104.449 91.6614C104.052 91.6614 103.655 91.5757 103.258 91.4042C102.861 91.2327 102.514 91 102.217 90.706L100.207 88.5748C99.1657 87.4479 97.9504 86.566 96.5614 85.9291C95.1724 85.2922 93.6842 84.9737 92.0968 84.9737C88.8228 84.9737 86.0945 86.2108 83.9118 88.685C81.7291 91.1592 80.6378 94.0866 80.6378 97.4672C80.6378 98.3491 80.7122 99.2187 80.861 100.076C81.0098 100.934 81.2579 101.779 81.6051 102.612H95.5197C96.0157 102.612 96.487 102.734 96.9335 102.979C97.3799 103.224 97.7272 103.542 97.9752 103.934L100.58 107.756L104.598 95.8504C104.796 95.2625 105.156 94.7725 105.677 94.3806C106.197 93.9886 106.78 93.7926 107.425 93.7926ZM108.318 103.346L104.3 115.252C104.102 115.84 103.73 116.33 103.184 116.722C102.638 117.114 102.043 117.31 101.398 117.31C100.902 117.31 100.431 117.187 99.9842 116.942C99.5378 116.697 99.1905 116.379 98.9425 115.987L93.8827 108.491H86.2929L103.928 125.908C104.027 126.006 104.114 126.067 104.188 126.092C104.263 126.116 104.35 126.129 104.449 126.129C104.548 126.129 104.635 126.116 104.709 126.092C104.784 126.067 104.87 126.006 104.97 125.908L122.53 108.491H113.378C112.882 108.491 112.411 108.368 111.964 108.123C111.518 107.878 111.146 107.56 110.848 107.168L108.318 103.346Z",
    fill: "#368C5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDimensionamento);
export default __webpack_public_path__ + "static/media/logoDimensionamento.2e48337b3cf33fba3316053b6e4f7003.svg";
export { ForwardRef as ReactComponent };